import { Navbar } from "@/projects/FinEaseHomeAndAdmin/pages/FinEaseHomePage/Navbar";
import { ReactNode } from "react";
import { Footer } from "@/projects/FinEaseHomeAndAdmin/pages/FinEaseHomePage/Footer";

interface ProductLayoutProps {
  children: ReactNode;
}

export const ProductLayout = ({ children }: ProductLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default ProductLayout;
